// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Pagination,
//   Badge,
//   Modal,
//   FloatingLabel,
//   InputGroup,
// } from "react-bootstrap";
// import {
//   BsEye
// } from "react-icons/bs";
// import {
//   FaFilter as FaFilterIcon,
//   // FaArrowRotateRight,
//   FaUser,
//   FaUserCog,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaIdBadge,
//   FaCheck,
//   FaTimes,
//   // FaFlag,
//   FaClipboardList,
// } from "react-icons/fa";
// import "./AdminReports.css";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// const STATUS_OPTIONS = [
//   "open",
//   "in_review",
//   "awaiting_party_response",
//   "resolved",
//   "dismissed",
// ];

// const PRIORITY_OPTIONS = ["low", "normal", "high", "urgent"];

// const ISSUE_MAP = {
//   service_quality: "Service quality issue",
//   behavior: "Customer behavior issue",
//   overcharge_or_payment: "Payment or overcharge problem",
//   late_or_no_show: "Customer not present / Late",
//   safety: "Safety concern",
//   lost_item: "Lost item",
//   damage: "Damage or property issue",
//   other: "Other issue",
// };

// const reporterLabel = (r) =>
//   r === "user" ? "User"
//   : r === "servitor" ? "Servitor"
//   : r === "admin" ? "Admin"
//   : r || "-";

// const AdminReports = () => {
//   // raw rows
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // filters / ui
//   const [search, setSearch] = useState("");
//   const [status, setStatus] = useState("All");
//   const [priority, setPriority] = useState("All");
//   const [serviceType, setServiceType] = useState("All");
//   const [reporterType, setReporterType] = useState("All");

//   // pagination (client-side)
//   const [page, setPage] = useState(1);
//   const limit = DEFAULT_LIMIT;

//   // modals
//   const [selected, setSelected] = useState(null);
//   const [showView, setShowView] = useState(false);

//   const [showEdit, setShowEdit] = useState(false);
//   const [editStatus, setEditStatus] = useState("open");
//   const [editPriority, setEditPriority] = useState("normal");
//   const [savingEdit, setSavingEdit] = useState(false);

//   const modalBackdropRef = useRef(null);

//   // fetch all (admin sees all from /reports/my)
//   const fetchReports = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       const { data } = await axios.get(`${URL}/reports/my`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       // normalize created_at/updated_at for sorting
//       const arr = Array.isArray(data) ? data : [];
//       arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//       setReports(arr);
//     } catch (e) {
//       console.error("Failed to load reports:", e);
//       setReports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReports();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // filter + search
//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     return reports.filter((r) => {
//       const matchesSearch =
//         !q ||
//         String(r.order_number || "").toLowerCase().includes(q) ||
//         String(r.subject || "").toLowerCase().includes(q) ||
//         String(r.description || "").toLowerCase().includes(q) ||
//         String(r.serviceType || "").toLowerCase().includes(q) ||
//         String(r?.User?.FirstName || "").toLowerCase().includes(q) ||
//         String(r?.User?.LastName || "").toLowerCase().includes(q) ||
//         String(r?.Servitor?.FirstName || "").toLowerCase().includes(q) ||
//         String(r?.Servitor?.LastName || "").toLowerCase().includes(q);

//       const matchesStatus = status === "All" || r.status === status;
//       const matchesPriority = priority === "All" || r.priority === priority;
//       const matchesService =
//         serviceType === "All" ||
//         String(r.serviceType || "").toLowerCase() === serviceType.toLowerCase();
//       const matchesReporter =
//         reporterType === "All" || r.reporterType === reporterType;

//       return matchesSearch && matchesStatus && matchesPriority && matchesService && matchesReporter;
//     });
//   }, [reports, search, status, priority, serviceType, reporterType]);

//   const totalPages = Math.max(1, Math.ceil(filtered.length / limit));
//   const current = Math.min(page, totalPages);
//   const slice = useMemo(() => {
//     const start = (current - 1) * limit;
//     return filtered.slice(start, start + limit);
//   }, [filtered, current]);

//   const handleOpenView = (r) => {
//     setSelected(r);
//     setShowView(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseView = () => {
//     setShowView(false);
//     setSelected(null);
//     document.body.style.overflow = "auto";
//   };

//   const handleOpenEdit = (r) => {
//     setSelected(r);
//     setEditStatus(r.status || "open");
//     setEditPriority(r.priority || "normal");
//     setShowEdit(true);
//   };
//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setSelected(null);
//   };

//   const submitEdit = async () => {
//     if (!selected) return;
//     try {
//       setSavingEdit(true);
//       const token = localStorage.getItem("token");
//       await axios.patch(
//         `${URL}/reports/${selected.Id}/status`,
//         { status: editStatus, priority: editPriority },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowEdit(false);
//       setSelected(null);
//       await fetchReports();
//       alert("Report updated.");
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to update report"
//       );
//     } finally {
//       setSavingEdit(false);
//     }
//   };

//   const resetFilters = () => {
//     setSearch("");
//     setStatus("All");
//     setPriority("All");
//     setServiceType("All");
//     setReporterType("All");
//     setPage(1);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1))
//       start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const badgeForStatus = (s) =>
//     `adminReports-badge adminReports-badge-${(s || "open").toLowerCase()}`;

//   const badgeForPriority = (p) =>
//     `adminReports-pill adminReports-pill-${(p || "normal").toLowerCase()}`;

//   return (
//     <Container fluid className="adminReports-container">
//       <Card className="adminReports-card">
//         <Card.Body>
//           <Card.Header className="adminReports-header">
//             <h4 className="adminReports-title">Support Reports</h4>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="align-items-center g-2 mb-3">
//             <Col lg={4}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by order, subject, description, name…"
//                   value={search}
//                   onChange={(e) => {
//                     setSearch(e.target.value);
//                     setPage(1);
//                   }}
//                   className="adminReports-search"
//                 />
//                 <InputGroup.Text className="adminReports-search-ico">
//                   <FaFilterIcon />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={status}
//                 onChange={(e) => {
//                   setStatus(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Status</option>
//                 {STATUS_OPTIONS.map((s) => (
//                   <option key={s} value={s}>
//                     {s.replaceAll("_", " ")}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={priority}
//                 onChange={(e) => {
//                   setPriority(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Priority</option>
//                 {PRIORITY_OPTIONS.map((p) => (
//                   <option key={p} value={p}>
//                     {p}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={reporterType}
//                 onChange={(e) => {
//                   setReporterType(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Reporters</option>
//                 <option value="user">User</option>
//                 <option value="servitor">Servitor</option>
//                 <option value="admin">Admin</option>
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={serviceType}
//                 onChange={(e) => {
//                   setServiceType(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Services</option>
//                 <option value="Electrician">Electrician</option>
//                 <option value="Home Cleaning">Home Cleaning</option>
//                 <option value="Plumber">Plumber</option>
//                 <option value="Gas Chula">Gas Chula</option>
//                 <option value="AC Service">AC Service</option>
//                 <option value="Filter">Filter</option>
//                 <option value="Tutor Service">Tutor Service</option>
//               </Form.Select>
//             </Col>
//           </Row>

//           <div className="adminReports-filter-actions">
//             <Button
//               variant="outline-secondary"
//               className="adminReports-reset"
//               onClick={resetFilters}
//             >
//               {/* <FaArrowRotateRight /> */}
//               Reset
//             </Button>
//           </div>

//           {/* Table */}
//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminReports-table"
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order</th>
//                 <th>Service</th>
//                 <th>Reporter</th>
//                 <th>Issue</th>
//                 <th>Status</th>
//                 <th>Priority</th>
//                 <th>Created</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!loading &&
//                 slice.map((r, idx) => (
//                   <tr key={r.Id}>
//                     <td>{(page - 1) * DEFAULT_LIMIT + idx + 1}</td>
//                     <td>
//                       <div className="adminReports-cell-main">
//                         <span className="adminReports-strong">
//                           {r.order_number}
//                         </span>
//                         {r.subject && (
//                           <span className="adminReports-muted">— {r.subject}</span>
//                         )}
//                       </div>
//                     </td>
//                     <td>{r.serviceType}</td>
//                     <td>{reporterLabel(r.reporterType)} #{r.reporterId}</td>
//                     <td>{ISSUE_MAP[r.issueType] || r.issueType}</td>
//                     <td>
//                       <Badge className={badgeForStatus(r.status)}>
//                         {r.status.replaceAll("_", " ")}
//                       </Badge>
//                     </td>
//                     <td>
//                       <span className={badgeForPriority(r.priority)}>
//                         {r.priority}
//                       </span>
//                     </td>
//                     <td>
//                       {new Date(r.createdAt).toLocaleString()}
//                     </td>
//                     <td>
//                       <div className="adminReports-actions">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenView(r)}
//                           title="View"
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-edit"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenEdit(r)}
//                           title="Edit"
//                         >
//                           <FaClipboardList size={14} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               {!loading && slice.length === 0 && (
//                 <tr>
//                   <td colSpan={9} style={{ textAlign: "center" }}>
//                     No reports found.
//                   </td>
//                 </tr>
//               )}
//               {loading && (
//                 <tr>
//                   <td colSpan={9} style={{ textAlign: "center" }}>
//                     Loading…
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination */}
//           <Pagination className="mt-3">
//             <Pagination.First
//               onClick={() => setPage(1)}
//               disabled={current === 1}
//             />
//             <Pagination.Prev
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               disabled={current === 1}
//             />
//             {getPageItems(totalPages, current).map((item, i) =>
//               item === "start-ellipsis" || item === "end-ellipsis" ? (
//                 <Pagination.Ellipsis key={item + i} disabled />
//               ) : (
//                 <Pagination.Item
//                   key={item}
//                   active={item === current}
//                   onClick={() => setPage(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               )
//             )}
//             <Pagination.Next
//               onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//               disabled={current === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => setPage(totalPages)}
//               disabled={current === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* ===== View Modal ===== */}
//       {showView && selected && (
//         <div className="adminReports-modal-backdrop" ref={modalBackdropRef}>
//           <div className="adminReports-modal">
//             <div className="adminReports-modal-header">
//               <button
//                 className="adminReports-modal-close"
//                 onClick={handleCloseView}
//               >
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminReports-modal-title">
//                   Report • {selected.order_number}
//                 </h2>
//                 <p className="adminReports-modal-subtitle">
//                   {selected.serviceType} • {ISSUE_MAP[selected.issueType] || selected.issueType}
//                 </p>
//               </div>
//             </div>

//             <div className="adminReports-modal-body">
//               {/* Summary badges */}
//               <div className="adminReports-summary">
//                 <Badge className={badgeForStatus(selected.status)}>
//                   {selected.status.replaceAll("_", " ")}
//                 </Badge>
//                 <span className={badgeForPriority(selected.priority)}>
//                   {selected.priority}
//                 </span>
//                 <span className="adminReports-chip">
//                   Reporter: {reporterLabel(selected.reporterType)} #{selected.reporterId}
//                 </span>
//                 <span className="adminReports-chip">
//                   Created: {new Date(selected.createdAt).toLocaleString()}
//                 </span>
//               </div>

//               {/* Order Details box */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">
//                   Order Information
//                 </h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Order Number</p>
//                     <p className="adminReports-detail-value">{selected.order_number}</p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Service</p>
//                     <p className="adminReports-detail-value">{selected.serviceType}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* User & Servitor */}
//               <div className="adminReports-grid-2">
//                 <div className="adminReports-detail-card">
//                   <h3 className="adminReports-detail-title">
//                     <FaUser style={{ marginRight: 8, color: "#10b981" }} />
//                     User
//                   </h3>
//                   <div className="adminReports-info-row">
//                     <FaUserCog className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Name</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User
//                           ? `${selected.User.FirstName || ""} ${selected.User.LastName || ""}`
//                           : "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaIdBadge className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">User ID</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User?.Id ?? selected?.userId ?? "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaPhone className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Mobile</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User?.mobile || "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaMapMarkerAlt className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">City / Area / Address</p>
//                       <p className="adminReports-detail-value">
//                         {[
//                           selected?.User?.city,
//                           selected?.User?.area || selected?.User?.thana,
//                           selected?.User?.Address,
//                         ]
//                           .filter(Boolean)
//                           .join(" — ") || "-"}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="adminReports-detail-card">
//                   <h3 className="adminReports-detail-title">
//                     <FaUserCog style={{ marginRight: 8, color: "#2563eb" }} />
//                     Servitor
//                   </h3>
//                   <div className="adminReports-info-row">
//                     <FaUser className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Name</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor
//                           ? `${selected.Servitor.FirstName || ""} ${selected.Servitor.LastName || ""}`
//                           : "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaIdBadge className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Servitor ID</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor?.Id ?? selected?.servitorId ?? "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaPhone className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Mobile</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor?.mobile || "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaMapMarkerAlt className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">City / Area / Address</p>
//                       <p className="adminReports-detail-value">
//                         {[
//                           selected?.Servitor?.city,
//                           selected?.Servitor?.area || selected?.Servitor?.thana,
//                           selected?.Servitor?.Address,
//                         ]
//                           .filter(Boolean)
//                           .join(" — ") || "-"}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Report Content</h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Subject</p>
//                     <p className="adminReports-detail-value">
//                       {selected.subject || "-"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Issue Type</p>
//                     <p className="adminReports-detail-value">
//                       {ISSUE_MAP[selected.issueType] || selected.issueType}
//                     </p>
//                   </div>
//                 </div>
//                 {selected.issueType === "lost_item" && (
//                   <div className="adminReports-two-col">
//                     <div>
//                       <p className="adminReports-detail-text">Lost Item</p>
//                       <p className="adminReports-detail-value">
//                         {selected.lostItemName || "-"}
//                       </p>
//                     </div>
//                     <div>
//                       <p className="adminReports-detail-text">Lost Item Details</p>
//                       <p className="adminReports-detail-value">
//                         {selected.lostItemDetails || "-"}
//                       </p>
//                     </div>
//                   </div>
//                 )}
//                 <div style={{ marginTop: 8 }}>
//                   <p className="adminReports-detail-text">Description</p>
//                   <p className="adminReports-detail-value">
//                     {selected.description || "-"}
//                   </p>
//                 </div>
//               </div>

//               <div className="adminReports-modal-footer">
//                 <div className="adminReports-footer-buttons">
//                   <button
//                     className="adminReports-footer-btn adminReports-footer-btn-close"
//                     onClick={handleCloseView}
//                   >
//                     <FaCheck /> Close
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ===== Edit Modal ===== */}
//       <Modal show={showEdit} onHide={handleCloseEdit} centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selected && (
//             <Row className="g-3">
//               <Col md={12}>
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   value={editStatus}
//                   onChange={(e) => setEditStatus(e.target.value)}
//                 >
//                   {STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s.replaceAll("_", " ")}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Col>
//               <Col md={12}>
//                 <Form.Label className="mt-2">Priority</Form.Label>
//                 <Form.Select
//                   value={editPriority}
//                   onChange={(e) => setEditPriority(e.target.value)}
//                 >
//                   {PRIORITY_OPTIONS.map((p) => (
//                     <option key={p} value={p}>
//                       {p}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <div className="small text-muted mt-1">
//                   Use <strong>urgent</strong> for safety or escalation-critical cases.
//                 </div>
//               </Col>
//               <Col md={12}>
//                 <FloatingLabel label="Notes (read-only from report)">
//                   <Form.Control
//                     as="textarea"
//                     style={{ height: 120 }}
//                     value={selected?.description || ""}
//                     readOnly
//                   />
//                 </FloatingLabel>
//               </Col>
//             </Row>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={handleCloseEdit} disabled={savingEdit}>
//             Cancel
//           </Button>
//           <Button variant="success" onClick={submitEdit} disabled={savingEdit}>
//             {savingEdit ? "Saving…" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default AdminReports;



// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Pagination,
//   Badge,
//   Modal,
//   FloatingLabel,
//   InputGroup,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaFilter as FaFilterIcon,
//   FaUser,
//   FaUserCog,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaIdBadge,
//   FaCheck,
//   FaTimes,
//   FaClipboardList,
// } from "react-icons/fa";
// import "./AdminReports.css";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// const STATUS_OPTIONS = [
//   "open",
//   "in_review",
//   "awaiting_party_response",
//   "resolved",
//   "dismissed",
// ];

// const PRIORITY_OPTIONS = ["low", "normal", "high", "urgent"];

// const ISSUE_MAP = {
//   service_quality: "Service quality issue",
//   behavior: "Customer behavior issue",
//   overcharge_or_payment: "Payment or overcharge problem",
//   late_or_no_show: "Customer not present / Late",
//   safety: "Safety concern",
//   lost_item: "Lost item",
//   damage: "Damage or property issue",
//   other: "Other issue",
// };

// const reporterLabel = (r) =>
//   r === "user" ? "User" : r === "servitor" ? "Servitor" : r === "admin" ? "Admin" : r || "-";

// // helpers for date/time formatting
// const fmtDate = (d) => {
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   const dd = String(dt.getDate()).padStart(2, "0");
//   const m = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][dt.getMonth()];
//   const yyyy = dt.getFullYear();
//   return `${dd}-${m}-${yyyy}`;
// };
// const fmtTime = (d) => {
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
// };

// const AdminReports = () => {
//   // data + meta from backend
//   const [rows, setRows] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     sortBy: "createdAt",
//     sortDir: "DESC",
//     search: "",
//     status: "",
//     priority: "",
//     reporterType: "",
//     serviceType: "",
//   });
//   const [loading, setLoading] = useState(true);

//   // filters / ui (controlled)
//   const [search, setSearch] = useState("");
//   const [status, setStatus] = useState("All");
//   const [priority, setPriority] = useState("All");
//   const [serviceType, setServiceType] = useState("All");
//   const [reporterType, setReporterType] = useState("All");
//   const [page, setPage] = useState(1);
//   const sortBy = "createdAt";
//   const sortDir = "DESC";

//   // modals
//   const [selected, setSelected] = useState(null);
//   const [showView, setShowView] = useState(false);
//   const [showEdit, setShowEdit] = useState(false);
//   const [editStatus, setEditStatus] = useState("open");
//   const [editPriority, setEditPriority] = useState("normal");
//   const [savingEdit, setSavingEdit] = useState(false);
//   const modalBackdropRef = useRef(null);

//   // fetch from backend with pagination + filters
//   const fetchReports = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       const { data } = await axios.get(`${URL}/reports/my`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page,
//           limit: DEFAULT_LIMIT,
//           search,
//           status: status === "All" ? "" : status,
//           priority: priority === "All" ? "" : priority,
//           reporterType: reporterType === "All" ? "" : reporterType,
//           serviceType: serviceType === "All" ? "" : serviceType,
//           sortBy,
//           sortDir,
//         },
//       });
//       setRows(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) setMeta(data.meta);
//       else
//         setMeta((m) => ({
//           ...m,
//           page,
//           limit: DEFAULT_LIMIT,
//           total: Array.isArray(data) ? data.length : 0,
//           totalPages: 1,
//           sortBy,
//           sortDir,
//           search,
//           status: status === "All" ? "" : status,
//           priority: priority === "All" ? "" : priority,
//           reporterType: reporterType === "All" ? "" : reporterType,
//           serviceType: serviceType === "All" ? "" : serviceType,
//         }));
//     } catch (e) {
//       console.error("Failed to load reports:", e);
//       setRows([]);
//       setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReports();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page, search, status, priority, serviceType, reporterType]);

//   // open/close
//   const handleOpenView = (r) => {
//     setSelected(r);
//     setShowView(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseView = () => {
//     setShowView(false);
//     setSelected(null);
//     document.body.style.overflow = "auto";
//   };
//   const handleOpenEdit = (r) => {
//     setSelected(r);
//     setEditStatus(r.status || "open");
//     setEditPriority(r.priority || "normal");
//     setShowEdit(true);
//   };
//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setSelected(null);
//   };

//   // save edit
//   const submitEdit = async () => {
//     if (!selected) return;
//     try {
//       setSavingEdit(true);
//       const token = localStorage.getItem("token");
//       await axios.patch(
//         `${URL}/reports/${selected.Id}/status`,
//         { status: editStatus, priority: editPriority },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowEdit(false);
//       setSelected(null);
//       await fetchReports();
//       alert("Report updated.");
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to update report"
//       );
//     } finally {
//       setSavingEdit(false);
//     }
//   };

//   // helpers
//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1))
//       start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const badgeForStatus = (s) =>
//     `adminReports-badge adminReports-badge-${(s || "open").toLowerCase()}`;
//   const badgeForPriority = (p) =>
//     `adminReports-pill adminReports-pill-${(p || "normal").toLowerCase()}`;

//   const totalPages = meta.totalPages || 1;

//   return (
//     <Container fluid className="adminReports-container">
//       <Card className="adminReports-card">
//         <Card.Body>
//           <Card.Header className="adminReports-header">
//             <h4 className="adminReports-title">Support Reports</h4>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="align-items-center g-2 mb-3">
//             <Col lg={4}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by order/subject/description/name/mobile…"
//                   value={search}
//                   onChange={(e) => {
//                     setSearch(e.target.value);
//                     setPage(1);
//                   }}
//                   className="adminReports-search"
//                 />
//                 <InputGroup.Text className="adminReports-search-ico">
//                   <FaFilterIcon />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={status}
//                 onChange={(e) => {
//                   setStatus(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Status</option>
//                 {STATUS_OPTIONS.map((s) => (
//                   <option key={s} value={s}>
//                     {s.replaceAll("_", " ")}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={priority}
//                 onChange={(e) => {
//                   setPriority(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Priority</option>
//                 {PRIORITY_OPTIONS.map((p) => (
//                   <option key={p} value={p}>
//                     {p}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={reporterType}
//                 onChange={(e) => {
//                   setReporterType(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Reporters</option>
//                 <option value="user">User</option>
//                 <option value="servitor">Servitor</option>
//                 <option value="admin">Admin</option>
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={serviceType}
//                 onChange={(e) => {
//                   setServiceType(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Services</option>
//                 <option value="Electrician">Electrician</option>
//                 <option value="Home Cleaning">Home Cleaning</option>
//                 <option value="Plumber">Plumber</option>
//                 <option value="Gas Chula">Gas Chula</option>
//                 <option value="AC Service">AC Service</option>
//                 <option value="Filter">Filter</option>
//                 <option value="Tutor Service">Tutor Service</option>
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Table */}
//           <Table striped bordered hover responsive className="adminReports-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order</th>
//                 <th>Service</th>
//                 <th>Reporter</th>
//                 <th>Issue</th>
//                 <th>Status</th>
//                 <th>Priority</th>
//                 <th>Created</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!loading &&
//                 rows.map((r, idx) => (
//                   <tr key={r.Id}>
//                     <td>{(meta.page - 1) * meta.limit + idx + 1}</td>
//                     <td>
//                       <div className="adminReports-cell-main">
//                         <span className="adminReports-strong">{r.order_number}</span>
//                         {r.subject && <span className="adminReports-muted">— {r.subject}</span>}
//                       </div>
//                     </td>
//                     <td>{r.serviceType}</td>
//                     <td>
//                       {reporterLabel(r.reporterType)} #{r.reporterId}
//                     </td>
//                     <td>{ISSUE_MAP[r.issueType] || r.issueType}</td>
//                     <td>
//                       <Badge className={badgeForStatus(r.status)}>
//                         {r.status.replaceAll("_", " ")}
//                       </Badge>
//                     </td>
//                     <td>
//                       <span className={badgeForPriority(r.priority)}>{r.priority}</span>
//                     </td>
//                     <td>
//                       <div className="adminReports-datetime">
//                         <div className="adminReports-date">Date: {fmtDate(r.createdAt)}</div>
//                         <div className="adminReports-time">Time: {fmtTime(r.createdAt)}</div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="adminReports-actions">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenView(r)}
//                           title="View"
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-edit"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenEdit(r)}
//                           title="Edit"
//                         >
//                           <FaClipboardList size={14} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               {!loading && rows.length === 0 && (
//                 <tr>
//                   <td colSpan={9} style={{ textAlign: "center" }}>
//                     No reports found.
//                   </td>
//                 </tr>
//               )}
//               {loading && (
//                 <tr>
//                   <td colSpan={9} style={{ textAlign: "center" }}>
//                     Loading…
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination from backend meta */}
//           <Pagination className="mt-3">
//             <Pagination.First onClick={() => setPage(1)} disabled={meta.page === 1} />
//             <Pagination.Prev
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               disabled={meta.page === 1}
//             />
//             {getPageItems(totalPages, meta.page).map((item, i) =>
//               item === "start-ellipsis" || item === "end-ellipsis" ? (
//                 <Pagination.Ellipsis key={item + i} disabled />
//               ) : (
//                 <Pagination.Item
//                   key={item}
//                   active={item === meta.page}
//                   onClick={() => setPage(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               )
//             )}
//             <Pagination.Next
//               onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//               disabled={meta.page === meta.totalPages}
//             />
//             <Pagination.Last
//               onClick={() => setPage(meta.totalPages)}
//               disabled={meta.page === meta.totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* ===== View Modal ===== */}
//       {showView && selected && (
//         <div className="adminReports-modal-backdrop" ref={modalBackdropRef}>
//           <div className="adminReports-modal">
//             <div className="adminReports-modal-header">
//               <button className="adminReports-modal-close" onClick={handleCloseView}>
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminReports-modal-title">Report • {selected.order_number}</h2>
//                 <p className="adminReports-modal-subtitle">
//                   {selected.serviceType} • {ISSUE_MAP[selected.issueType] || selected.issueType}
//                 </p>
//               </div>
//             </div>

//             <div className="adminReports-modal-body">
//               {/* Summary badges */}
//               <div className="adminReports-summary">
//                 <Badge className={badgeForStatus(selected.status)}>
//                   {selected.status.replaceAll("_", " ")}
//                 </Badge>
//                 <span className={badgeForPriority(selected.priority)}>{selected.priority}</span>
//                 <span className="adminReports-chip">
//                   Reporter: {reporterLabel(selected.reporterType)} #{selected.reporterId}
//                 </span>
//                 <span className="adminReports-chip">Date: {fmtDate(selected.createdAt)}</span>
//                 <span className="adminReports-chip">Time: {fmtTime(selected.createdAt)}</span>
//               </div>

//               {/* Order Details */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Order Information</h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Order Number</p>
//                     <p className="adminReports-detail-value">{selected.order_number}</p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Service</p>
//                     <p className="adminReports-detail-value">{selected.serviceType}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* User & Servitor */}
//               <div className="adminReports-grid-2">
//                 <div className="adminReports-detail-card">
//                   <h3 className="adminReports-detail-title">
//                     <FaUser className="adminReports-title-icon user" />
//                     User
//                   </h3>
//                   <div className="adminReports-info-row">
//                     <FaUserCog className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Name</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User
//                           ? `${selected.User.FirstName || ""} ${selected.User.LastName || ""}`
//                           : "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaIdBadge className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">User ID</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User?.Id ?? selected?.userId ?? "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaPhone className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Mobile</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.User?.mobile || "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaMapMarkerAlt className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">City / Area / Address</p>
//                       <p className="adminReports-detail-value">
//                         {[selected?.User?.city, selected?.User?.area || selected?.User?.thana, selected?.User?.Address]
//                           .filter(Boolean)
//                           .join(" — ") || "-"}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="adminReports-detail-card">
//                   <h3 className="adminReports-detail-title">
//                     <FaUserCog className="adminReports-title-icon servitor" />
//                     Servitor
//                   </h3>
//                   <div className="adminReports-info-row">
//                     <FaUser className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Name</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor
//                           ? `${selected.Servitor.FirstName || ""} ${selected.Servitor.LastName || ""}`
//                           : "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaIdBadge className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Servitor ID</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor?.Id ?? selected?.servitorId ?? "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaPhone className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">Mobile</p>
//                       <p className="adminReports-detail-value">
//                         {selected?.Servitor?.mobile || "-"}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminReports-info-row">
//                     <FaMapMarkerAlt className="adminReports-icon" />
//                     <div>
//                       <p className="adminReports-detail-text">City / Area / Address</p>
//                       <p className="adminReports-detail-value">
//                         {[selected?.Servitor?.city, selected?.Servitor?.area || selected?.Servitor?.thana, selected?.Servitor?.Address]
//                           .filter(Boolean)
//                           .join(" — ") || "-"}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Report Content */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Report Content</h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Subject</p>
//                     <p className="adminReports-detail-value">{selected.subject || "-"}</p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Issue Type</p>
//                     <p className="adminReports-detail-value">
//                       {ISSUE_MAP[selected.issueType] || selected.issueType}
//                     </p>
//                   </div>
//                 </div>
//                 {selected.issueType === "lost_item" && (
//                   <div className="adminReports-two-col">
//                     <div>
//                       <p className="adminReports-detail-text">Lost Item</p>
//                       <p className="adminReports-detail-value">{selected.lostItemName || "-"}</p>
//                     </div>
//                     <div>
//                       <p className="adminReports-detail-text">Lost Item Details</p>
//                       <p className="adminReports-detail-value">{selected.lostItemDetails || "-"}</p>
//                     </div>
//                   </div>
//                 )}
//                 <div style={{ marginTop: 8 }}>
//                   <p className="adminReports-detail-text">Description</p>
//                   <p className="adminReports-detail-value">{selected.description || "-"}</p>
//                 </div>
//               </div>

//               <div className="adminReports-modal-footer">
//                 <div className="adminReports-footer-buttons">
//                   <button
//                     className="adminReports-footer-btn adminReports-footer-btn-close"
//                     onClick={handleCloseView}
//                   >
//                     <FaCheck /> Close
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ===== Edit Modal ===== */}
//       <Modal show={showEdit} onHide={handleCloseEdit} centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selected && (
//             <Row className="g-3">
//               <Col md={12}>
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
//                   {STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s.replaceAll("_", " ")}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Col>
//               <Col md={12}>
//                 <Form.Label className="mt-2">Priority</Form.Label>
//                 <Form.Select value={editPriority} onChange={(e) => setEditPriority(e.target.value)}>
//                   {PRIORITY_OPTIONS.map((p) => (
//                     <option key={p} value={p}>
//                       {p}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <div className="small text-muted mt-1">
//                   Use <strong>urgent</strong> for safety or escalation-critical cases.
//                 </div>
//               </Col>
//               <Col md={12}>
//                 <FloatingLabel label="Notes (read-only from report)">
//                   <Form.Control
//                     as="textarea"
//                     style={{ height: 120 }}
//                     value={selected?.description || ""}
//                     readOnly
//                   />
//                 </FloatingLabel>
//               </Col>
//             </Row>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={handleCloseEdit} disabled={savingEdit}>
//             Cancel
//           </Button>
//           <Button variant="success" onClick={submitEdit} disabled={savingEdit}>
//             {savingEdit ? "Saving…" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default AdminReports;




// ***** Upper code is okay, Updated ith auth Protect (2-Dec-2025) ***** //
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Pagination,
  Badge,
  Modal,
  FloatingLabel,
  InputGroup,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import {
  FaFilter as FaFilterIcon,
  FaUser,
  FaUserCog,
  FaPhone,
  FaMapMarkerAlt,
  FaIdBadge,
  FaCheck,
  FaTimes,
  FaClipboardList,
} from "react-icons/fa";
import "./AdminReports.css";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;

const STATUS_OPTIONS = [
  "open",
  "in_review",
  "awaiting_party_response",
  "resolved",
  "dismissed",
];

const PRIORITY_OPTIONS = ["low", "normal", "high", "urgent"];

const ISSUE_MAP = {
  service_quality: "Service quality issue",
  behavior: "Customer behavior issue",
  overcharge_or_payment: "Payment or overcharge problem",
  late_or_no_show: "Customer not present / Late",
  safety: "Safety concern",
  lost_item: "Lost item",
  damage: "Damage or property issue",
  other: "Other issue",
};

const reporterLabel = (r) =>
  r === "user"
    ? "User"
    : r === "servitor"
    ? "Servitor"
    : r === "admin"
    ? "Admin"
    : r || "-";

// helpers for date/time formatting
const fmtDate = (d) => {
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  const dd = String(dt.getDate()).padStart(2, "0");
  const m = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][dt.getMonth()];
  const yyyy = dt.getFullYear();
  return `${dd}-${m}-${yyyy}`;
};
const fmtTime = (d) => {
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

const AdminReports = () => {
  // data + meta from backend
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    sortBy: "createdAt",
    sortDir: "DESC",
    search: "",
    status: "",
    priority: "",
    reporterType: "",
    serviceType: "",
  });
  const [loading, setLoading] = useState(true);

  // filters / ui (controlled)
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [priority, setPriority] = useState("All");
  const [serviceType, setServiceType] = useState("All");
  const [reporterType, setReporterType] = useState("All");
  const [page, setPage] = useState(1);
  const sortBy = "createdAt";
  const sortDir = "DESC";

  // modals
  const [selected, setSelected] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editStatus, setEditStatus] = useState("open");
  const [editPriority, setEditPriority] = useState("normal");
  const [savingEdit, setSavingEdit] = useState(false);
  const modalBackdropRef = useRef(null);

  // fetch from backend with pagination + filters
  const fetchReports = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
      if (!token) {
        console.warn("No adminToken found in localStorage for AdminReports.");
        setRows([]);
        setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
        return;
      }

      const { data } = await axios.get(`${URL}/reports/my`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page,
          limit: DEFAULT_LIMIT,
          search,
          status: status === "All" ? "" : status,
          priority: priority === "All" ? "" : priority,
          reporterType: reporterType === "All" ? "" : reporterType,
          serviceType: serviceType === "All" ? "" : serviceType,
          sortBy,
          sortDir,
        },
      });

      setRows(Array.isArray(data?.data) ? data.data : []);
      if (data?.meta) {
        setMeta(data.meta);
      } else {
        setMeta((m) => ({
          ...m,
          page,
          limit: DEFAULT_LIMIT,
          total: Array.isArray(data) ? data.length : 0,
          totalPages: 1,
          sortBy,
          sortDir,
          search,
          status: status === "All" ? "" : status,
          priority: priority === "All" ? "" : priority,
          reporterType: reporterType === "All" ? "" : reporterType,
          serviceType: serviceType === "All" ? "" : serviceType,
        }));
      }
    } catch (e) {
      console.error("Failed to load reports:", e);
      setRows([]);
      setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, status, priority, serviceType, reporterType]);

  // open/close
  const handleOpenView = (r) => {
    setSelected(r);
    setShowView(true);
    document.body.style.overflow = "hidden";
  };
  const handleCloseView = () => {
    setShowView(false);
    setSelected(null);
    document.body.style.overflow = "auto";
  };
  const handleOpenEdit = (r) => {
    setSelected(r);
    setEditStatus(r.status || "open");
    setEditPriority(r.priority || "normal");
    setShowEdit(true);
  };
  const handleCloseEdit = () => {
    setShowEdit(false);
    setSelected(null);
  };

  // save edit
  const submitEdit = async () => {
    if (!selected) return;
    try {
      setSavingEdit(true);
      const token = localStorage.getItem("adminToken");
      if (!token) {
        alert("Missing adminToken. Please log in again.");
        return;
      }

      await axios.patch(
        `${URL}/reports/${selected.Id}/status`,
        { status: editStatus, priority: editPriority },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowEdit(false);
      setSelected(null);
      await fetchReports();
      alert("Report updated.");
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Failed to update report"
      );
    } finally {
      setSavingEdit(false);
    }
  };

  // helpers
  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);

    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));

    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  const badgeForStatus = (s) =>
    `adminReports-badge adminReports-badge-${(s || "open").toLowerCase()}`;
  const badgeForPriority = (p) =>
    `adminReports-pill adminReports-pill-${(p || "normal").toLowerCase()}`;

  const totalPages = meta.totalPages || 1;

  return (
    <Container fluid className="adminReports-container">
      <Card className="adminReports-card">
        <Card.Body>
          <Card.Header className="adminReports-header">
            <h4 className="adminReports-title">Support Reports</h4>
          </Card.Header>

          {/* Filters */}
          <Row className="align-items-center g-2 mb-3">
            <Col lg={4}>
              <InputGroup>
                <Form.Control
                  placeholder="Search by order/subject/description/name/mobile…"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                  className="adminReports-search"
                />
                <InputGroup.Text className="adminReports-search-ico">
                  <FaFilterIcon />
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Status</option>
                {STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s.replaceAll("_", " ")}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={priority}
                onChange={(e) => {
                  setPriority(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Priority</option>
                {PRIORITY_OPTIONS.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={reporterType}
                onChange={(e) => {
                  setReporterType(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Reporters</option>
                <option value="user">User</option>
                <option value="servitor">Servitor</option>
                <option value="admin">Admin</option>
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={serviceType}
                onChange={(e) => {
                  setServiceType(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Services</option>
                <option value="Electrician">Electrician</option>
                <option value="Home Cleaning">Home Cleaning</option>
                <option value="Plumber">Plumber</option>
                <option value="Gas Chula">Gas Chula</option>
                <option value="AC Service">AC Service</option>
                <option value="Filter">Filter</option>
                <option value="Tutor Service">Tutor Service</option>
              </Form.Select>
            </Col>
          </Row>

          {/* Table */}
          <Table
            striped
            bordered
            hover
            responsive
            className="adminReports-table"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Order</th>
                <th>Service</th>
                <th>Reporter</th>
                <th>Issue</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                rows.map((r, idx) => (
                  <tr key={r.Id}>
                    <td>{(meta.page - 1) * meta.limit + idx + 1}</td>
                    <td>
                      <div className="adminReports-cell-main">
                        <span className="adminReports-strong">
                          {r.order_number}
                        </span>
                        {r.subject && (
                          <span className="adminReports-muted">
                            — {r.subject}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>{r.serviceType}</td>
                    <td>
                      {reporterLabel(r.reporterType)} #{r.reporterId}
                    </td>
                    <td>{ISSUE_MAP[r.issueType] || r.issueType}</td>
                    <td>
                      <Badge className={badgeForStatus(r.status)}>
                        {r.status.replaceAll("_", " ")}
                      </Badge>
                    </td>
                    <td>
                      <span className={badgeForPriority(r.priority)}>
                        {r.priority}
                      </span>
                    </td>
                    <td>
                      <div className="adminReports-datetime">
                        <div className="adminReports-date">
                          Date: {fmtDate(r.createdAt)}
                        </div>
                        <div className="adminReports-time">
                          Time: {fmtTime(r.createdAt)}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="adminReports-actions">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="adminReports-action-btn"
                          onClick={() => handleOpenView(r)}
                          title="View"
                        >
                          <BsEye size={16} />
                        </Button>
                        <Button
                          variant="outline-edit"
                          size="sm"
                          className="adminReports-action-btn"
                          onClick={() => handleOpenEdit(r)}
                          title="Edit"
                        >
                          <FaClipboardList size={14} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={9} style={{ textAlign: "center" }}>
                    No reports found.
                  </td>
                </tr>
              )}
              {loading && (
                <tr>
                  <td colSpan={9} style={{ textAlign: "center" }}>
                    Loading…
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination from backend meta */}
          <Pagination className="mt-3">
            <Pagination.First
              onClick={() => setPage(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={meta.page === 1}
            />
            {getPageItems(totalPages, meta.page).map((item, i) =>
              item === "start-ellipsis" || item === "end-ellipsis" ? (
                <Pagination.Ellipsis key={item + i} disabled />
              ) : (
                <Pagination.Item
                  key={item}
                  active={item === meta.page}
                  onClick={() => setPage(item)}
                >
                  {item}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => setPage(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {/* ===== View Modal ===== */}
      {showView && selected && (
        <div className="adminReports-modal-backdrop" ref={modalBackdropRef}>
          <div className="adminReports-modal">
            <div className="adminReports-modal-header">
              <button
                className="adminReports-modal-close"
                onClick={handleCloseView}
              >
                <FaTimes size={20} />
              </button>
              <div>
                <h2 className="adminReports-modal-title">
                  Report • {selected.order_number}
                </h2>
                <p className="adminReports-modal-subtitle">
                  {selected.serviceType} •{" "}
                  {ISSUE_MAP[selected.issueType] || selected.issueType}
                </p>
              </div>
            </div>

            <div className="adminReports-modal-body">
              {/* Summary badges */}
              <div className="adminReports-summary">
                <Badge className={badgeForStatus(selected.status)}>
                  {selected.status.replaceAll("_", " ")}
                </Badge>
                <span className={badgeForPriority(selected.priority)}>
                  {selected.priority}
                </span>
                <span className="adminReports-chip">
                  Reporter: {reporterLabel(selected.reporterType)} #
                  {selected.reporterId}
                </span>
                <span className="adminReports-chip">
                  Date: {fmtDate(selected.createdAt)}
                </span>
                <span className="adminReports-chip">
                  Time: {fmtTime(selected.createdAt)}
                </span>
              </div>

              {/* Order Details */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">
                  Order Information
                </h3>
                <div className="adminReports-two-col">
                  <div>
                    <p className="adminReports-detail-text">Order Number</p>
                    <p className="adminReports-detail-value">
                      {selected.order_number}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Service</p>
                    <p className="adminReports-detail-value">
                      {selected.serviceType}
                    </p>
                  </div>
                </div>
              </div>

              {/* User & Servitor */}
              <div className="adminReports-grid-2">
                <div className="adminReports-detail-card">
                  <h3 className="adminReports-detail-title">
                    <FaUser className="adminReports-title-icon user" />
                    User
                  </h3>
                  <div className="adminReports-info-row">
                    <FaUserCog className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">Name</p>
                      <p className="adminReports-detail-value">
                        {selected?.User
                          ? `${selected.User.FirstName || ""} ${
                              selected.User.LastName || ""
                            }`
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaIdBadge className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">User ID</p>
                      <p className="adminReports-detail-value">
                        {selected?.User?.Id ?? selected?.userId ?? "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaPhone className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">Mobile</p>
                      <p className="adminReports-detail-value">
                        {selected?.User?.mobile || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaMapMarkerAlt className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">
                        City / Area / Address
                      </p>
                      <p className="adminReports-detail-value">
                        {[
                          selected?.User?.city,
                          selected?.User?.area || selected?.User?.thana,
                          selected?.User?.Address,
                        ]
                          .filter(Boolean)
                          .join(" — ") || "-"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="adminReports-detail-card">
                  <h3 className="adminReports-detail-title">
                    <FaUserCog className="adminReports-title-icon servitor" />
                    Servitor
                  </h3>
                  <div className="adminReports-info-row">
                    <FaUser className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">Name</p>
                      <p className="adminReports-detail-value">
                        {selected?.Servitor
                          ? `${selected.Servitor.FirstName || ""} ${
                              selected.Servitor.LastName || ""
                            }`
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaIdBadge className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">Servitor ID</p>
                      <p className="adminReports-detail-value">
                        {selected?.Servitor?.Id ??
                          selected?.servitorId ??
                          "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaPhone className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">Mobile</p>
                      <p className="adminReports-detail-value">
                        {selected?.Servitor?.mobile || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="adminReports-info-row">
                    <FaMapMarkerAlt className="adminReports-icon" />
                    <div>
                      <p className="adminReports-detail-text">
                        City / Area / Address
                      </p>
                      <p className="adminReports-detail-value">
                        {[
                          selected?.Servitor?.city,
                          selected?.Servitor?.area ||
                            selected?.Servitor?.thana,
                          selected?.Servitor?.Address,
                        ]
                          .filter(Boolean)
                          .join(" — ") || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Report Content */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">Report Content</h3>
                <div className="adminReports-two-col">
                  <div>
                    <p className="adminReports-detail-text">Subject</p>
                    <p className="adminReports-detail-value">
                      {selected.subject || "-"}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Issue Type</p>
                    <p className="adminReports-detail-value">
                      {ISSUE_MAP[selected.issueType] || selected.issueType}
                    </p>
                  </div>
                </div>
                {selected.issueType === "lost_item" && (
                  <div className="adminReports-two-col">
                    <div>
                      <p className="adminReports-detail-text">Lost Item</p>
                      <p className="adminReports-detail-value">
                        {selected.lostItemName || "-"}
                      </p>
                    </div>
                    <div>
                      <p className="adminReports-detail-text">
                        Lost Item Details
                      </p>
                      <p className="adminReports-detail-value">
                        {selected.lostItemDetails || "-"}
                      </p>
                    </div>
                  </div>
                )}
                <div style={{ marginTop: 8 }}>
                  <p className="adminReports-detail-text">Description</p>
                  <p className="adminReports-detail-value">
                    {selected.description || "-"}
                  </p>
                </div>
              </div>

              <div className="adminReports-modal-footer">
                <div className="adminReports-footer-buttons">
                  <button
                    className="adminReports-footer-btn adminReports-footer-btn-close"
                    onClick={handleCloseView}
                  >
                    <FaCheck /> Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== Edit Modal ===== */}
      <Modal show={showEdit} onHide={handleCloseEdit} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Edit Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <Row className="g-3">
              <Col md={12}>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s.replaceAll("_", " ")}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={12}>
                <Form.Label className="mt-2">Priority</Form.Label>
                <Form.Select
                  value={editPriority}
                  onChange={(e) => setEditPriority(e.target.value)}
                >
                  {PRIORITY_OPTIONS.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </Form.Select>
                <div className="small text-muted mt-1">
                  Use <strong>urgent</strong> for safety or
                  escalation-critical cases.
                </div>
              </Col>
              <Col md={12}>
                <FloatingLabel label="Notes (read-only from report)">
                  <Form.Control
                    as="textarea"
                    style={{ height: 120 }}
                    value={selected?.description || ""}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={handleCloseEdit}
            disabled={savingEdit}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={submitEdit}
            disabled={savingEdit}
          >
            {savingEdit ? "Saving…" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminReports;
